import { useAbortableRequest } from '@/hooks/useAbortableRequest'
import { useUserStore } from '@/hooks/useUserStore'

const TYPE_LIST = [
  { label: '开题报告', icon: 'icon-icon-jia', type: 1 },
  { label: '文献综述', icon: 'icon-icon-jia', type: 2 },
  { label: '毕业论文', icon: 'icon-icon-jia', type: 3 },
  { label: '课程论文', icon: 'icon-icon-jia', type: 4 },
  { label: '答辩PPT', icon: 'icon-icon-jia', type: 5 },
  { label: '降重', icon: 'icon-icon-jia', type: 6 },
  { label: '降AIGC', icon: 'icon-icon-jia', type: 7 },
  { label: '格式排版', icon: 'icon-icon-jia', type: 8 }
]

export const useUserAccount = () => {
  const { sendRequest } = useAbortableRequest()
  const { dispatch } = useUserStore()

  const fetchUserAccount = async () => {
    const result: any = await sendRequest({ method: 'post', url: 'user_account', data: {} })
    if (result?.res) {
      const o = result?.res?.data?.account.reduce((acc: { [x: string]: any }, { type, count }: any) => {
        acc[type] = count
        return acc
      }, {})
      // 排序 有值的放在前面
      const [exist, notExist] = TYPE_LIST.reduce(
        (acc: [any[], any[]], item: any) => {
          const copy = { ...item }
          if (o[item.type]) {
            acc[0].push(copy)
          } else {
            acc[1].push(copy)
          }
          return acc
        },
        [[], []]
      )
      dispatch({ type: 'SET_USER_ACCOUNT', payload: [...(exist ?? []), ...(notExist ?? [])] })
      dispatch({ type: 'SET_USER_ORDER', payload: result?.res?.data?.order_list || [] })
      dispatch({ type: 'SET_USER_USAGE', payload: result?.res?.data?.usage_list || [] })
      dispatch({ type: 'SET_PAY_ACCOUNT', payload: o })
    }
  }

  return { fetchUserAccount }
}
